import { useState } from 'react';

const languages = [
  { code: 'en', name: 'US English', flag: '🇺🇸' },
  { code: 'zh', name: 'Chinese', flag: '🇨🇳', redirect: 'https://cn.titron.org' }
];

export default function LanguageSwitcher() {
  const [isOpen, setIsOpen] = useState(false);

  const handleLanguageClick = (lng: typeof languages[0]) => {
    if (lng.redirect) {
      // Redirect to Chinese version
      window.open(lng.redirect, '_blank');
    } else {
      // English version (default)
      console.log('Already on English version');
    }
    setIsOpen(false);
  };

  const currentLanguageData = languages[0]; // Default to English

  return (
    <div className="relative">
      {/* Language switcher button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-3 py-2 text-sm font-semibold text-gray-800 hover:text-gray-900 bg-white/10 hover:bg-white/20 rounded-lg transition-all duration-200 backdrop-blur-sm border border-white/20"
        aria-label="Select language"
      >
        <span className="text-2xl">{currentLanguageData.flag}</span>
        <span className="hidden sm:inline font-medium">{currentLanguageData.name}</span>
        <svg
          className={`w-4 h-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {/* Dropdown menu */}
      {isOpen && (
        <div className="absolute right-0 mt-2 w-56 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 z-50">
          <div className="py-1">
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => handleLanguageClick(lang)}
                className={`w-full flex items-center space-x-3 px-4 py-2 text-sm hover:bg-gray-100 transition-colors duration-200 ${
                  lang.code === 'en' ? 'bg-blue-50 text-blue-700' : 'text-gray-700'
                }`}
              >
                <span className="text-lg">{lang.flag}</span>
                <span>{lang.name}</span>
                {lang.code === 'en' && (
                  <svg className="w-4 h-4 ml-auto" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                )}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Click outside to close menu */}
      {isOpen && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
}
